import { render } from "./SignatureAnnotation.vue?vue&type=template&id=791ee97e&scoped=true"
import script from "./SignatureAnnotation.vue?vue&type=script&lang=js"
export * from "./SignatureAnnotation.vue?vue&type=script&lang=js"

import "./SignatureAnnotation.vue?vue&type=style&index=0&id=791ee97e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-791ee97e"]])

export default __exports__